import { Layout, Menu, Divider, Button } from "antd";
import { rgba, cssVar } from "polished";
import styled from "styled-components";
const { Sider } = Layout;
const { Item, SubMenu } = Menu;

const colorsHelper = () => {
  const defaultValue = "#fff";
  return {
    "--color-brand-100": cssVar("--color-brand-100", defaultValue),
    "--opacity-level-5": cssVar("--opacity-level-5", defaultValue),
  };
};
export const LayoutSider = styled(Sider)`
  background-color: ${(props) => props.theme["@secondary-color"]};
  z-index: 4;

  &.ant-layout-sider-collapsed {
    max-width: 60px !important;
    min-width: 60px !important;
    width: 60px;
    .ant-layout-sider-children > div a span {
      margin-left: -10px;
    }
  }

  &.ant-layout-sider {
    transition: none;
  }
  .ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
    margin-top: -4px;
    width: 60px;
    height: 100%;
  }
  .ant-menu-inline {
    margin-top: -5px;
    height: 100%;
  }

  .ant-menu-vertical .ant-menu-submenu,
  .ant-menu-vertical-left .ant-menu-submenu,
  .ant-menu-vertical-right .ant-menu-submenu,
  .ant-menu-inline .ant-menu-submenu {
    padding-bottom: 0px !important;
  }
  position: relative;
`;

export const ButtonArrowBack = styled(Button)`
  height: 30px;
  border: none;
  margin: 1px 8px 0 -12px;
  outline: none;
  color: ${(props) => props.theme.colors.text};
  box-shadow: none;
  background-color: ${(props) => props.theme["@secondary-color"]};
`;

export const MenuLayout = styled(Menu)`
  background: ${(props) => props.theme["@secondary-color"]};
  position: fixed;
  margin-top: 56px !important;
  width: 237px;
  .ant-menu-item-selected {
    border-right: 3px solid ${(props) => props.theme["@primary-color-brand"]};
    color: ${(props) => props.theme.colors.text};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    background-color: ${(props) => props.theme["@hover-menu-item"]} !important;
    :hover {
      background-color: ${(props) => props.theme["@hover-menu-item"]} !important;
    }
  }

  .ant-layout-sider-children.ant-menu.ant-menu-inline-collapsed {
    width: 60px !important;
  }

  .ant-menu-item:hover {
    background-color: ${(props) => props.theme["@hover-menu-item"]} !important;
  }

  .ant-menu-submenu-title:hover {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }
  .ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-title {
    padding-left: 22px !important;
  }

  .ant-menu-submenu-title {
    padding-left: 25px !important;
  }

  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected,
  .ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-selected {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  .ant-menu-item.ant-menu-item-active.ant-menu-item-selected.ant-menu-item-only-child.ant-menu-title-content {
    font-weight: ${(props) => props.theme["@bold-font-weight"]} !important;
  }

  .ant-menu-item-selected a {
    color: ${(props) => props.theme.colors.text};
  }

  .ant-menu-item a {
    color: ${(props) => props.theme.colors.text};
  }

  &.ant-menu-inline {
    border-right: none;
  }

  &.ant-menu-vertical {
    border-right: 0;
  }
`;

export const LogoSidebar = styled.div`
  display: flex;
  margin: 16px 20px 14px 19px;
  position: fixed;
  width: 60px;
  padding: 0;
  > img {
    height: 30px;
  }
  > button {
    height: 30px;
    border: none;
    outline: none;
    color: ${(props) => props.theme.colors.text};
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
    cursor: pointer;
    padding-top: -1px;
  }
  .logoIcon {
    height: 31px;
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
  .hamburguerIcon,
  .arrowBackIcon {
    color: ${(props) => props.theme.colors.text} !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
  }
  .hamburguerButton {
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
  }
`;

export const LineDividerSidebar = styled(Divider)`
  background-color: ${(props) => props.theme["@secondary-color"]} !important;
  height: 64px;
  width: 2px;
  margin: -18px 9px -18px 1px;
  border: none;
`;

export const LayoutSidebar: React.CSSProperties = {
  minHeight: "100vh",
};

export const MenuItemLayout = styled(Item)`
  background: ${(props) => props.theme["@secondary-color"]};
  color: ${(props) => props.theme.colors.text};
  font-family: ${(props) => props.theme["@font-family"]};
  margin-left: -1px;
  :hover {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }

  .iconItem:active {
    background-color: ${(props) => props.theme["@hover-input-background-color"]};
    border: 0;
    background: none;
    -webkit-appearance: none;
    &:hover {
      color: ${(props) => props.theme.colors.text};
    }
  }
  .iconItem > svg {
    margin: -3px;
  }
`;

export const SubMenuItemLayout = styled(SubMenu)`
  background: ${(props) => props.theme["@secondary-color"]};
  color: ${(props) => props.theme.colors.text};
  font-family: ${(props) => props.theme["@font-family"]};
  margin: 0;

  &:hover {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }

  .ant-menu-light.ant-menu-item-active,
  .ant-menu-light.ant-menu-item:hover {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }

  .iconItem:active {
    border: 0;
    background: none;
    -webkit-appearance: none;
    &:hover {
      color: ${(props) => props.theme.colors.text};
    }
  }

  .ant-menu-item-selected.ant-menu-item-only-child,
  .ant-menu-item-selected {
    background-color: none !important;
  }

  .iconItem > svg {
    margin: -3px;
  }

  &.ant-menu-submenu {
    margin-left: -3px !important;
  }

  .ant-menu-submenu-arrow {
    color: ${(props) => props.theme.colors.text};
    :hover {
      color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-menu-sub.ant-menu-inline > .ant-menu-item {
    margin: -1px !important;
  }
  .ant-menu-submenu .ant-menu-submenu-inline {
    margin: 0;
  }
`;

export const HideMenuItemLayout = styled(Item)`
  display: none !important;
`;
